/* eslint-disable func-style */
// 收据管理
const ReceiptPrinting = () => import('@/pages/ReceiptManagement/ReceiptPrinting.vue');// 收款单打印
const ReceiptPrintingDetail = () => import('@/pages/ReceiptManagement/ReceiptPrintingDetail.vue');
const RefundOrderPrinting = () => import('@/pages/ReceiptManagement/RefundOrderPrinting.vue');// 退款单打印
const RefundOrderPrintDet = () => import('@/pages/ReceiptManagement/RefundOrderPrintDet.vue');
const PrintRecord = () => import('@/pages/ReceiptManagement/PrintRecord.vue');// 打印记录
const PrintRecordDetails = () => import('@/pages/ReceiptManagement/PrintRecordDetails.vue');
const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面

const ReceiptRouter = [
	{
		path: '/ReceiptPrinting',
		name: 'ReceiptPrinting',
		component: ReceiptPrinting,
		children: [
			{
				path: 'ReceiptPrintRightPanel',
				name: 'ReceiptPrintRightPanel',
				component: RightPanel,
				meta: { parent: '/ReceiptPrinting' },
				children: [
					{ // 右滑详情页面
						path: '/ReceiptPrintingDetail',
						name: 'ReceiptPrintingDetail',
						meta: { parent: '/ReceiptPrinting' },
						component: ReceiptPrintingDetail,
					},
				],
			},
		],
	},
	{
		path: '/RefundOrderPrinting',
		name: 'RefundOrderPrinting',
		component: RefundOrderPrinting,
		children: [
			{
				path: 'RefundOrderPrintRightPanel',
				name: 'RefundOrderPrintRightPanel',
				meta: { parent: '/RefundOrderPrinting' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/RefundOrderPrintDet',
						name: 'RefundOrderPrintDet',
						meta: { parent: '/RefundOrderPrinting' },
						component: RefundOrderPrintDet,
					},
				],
			},
		],
	},
	{
		path: '/PrintRecord',
		name: 'PrintRecord',
		component: PrintRecord,
		children: [
			{
				path: 'PrintRecordRightPanel',
				name: 'PrintRecordRightPanel',
				meta: { parent: '/PrintRecord' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/PrintRecordDetails/:details',
						name: 'PrintRecordDetails',
						meta: { parent: '/PrintRecord' },
						component: PrintRecordDetails,
					},
				],
			},
		],
	},
];

export default ReceiptRouter;
